import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { getItem, setItem } from 'utils/localStorage';

export const useInviteCode = () => {
  const searchParams = useSearchParams();
  const ref = searchParams.get('ref');

  const [inviteCode, setInviteCode] = useState(null);

  useEffect(() => {
    if (ref) {
      setItem('inviteCode', ref);
      setInviteCode(ref);
    } else {
      const storedInviteCode = getItem('inviteCode');
      if (storedInviteCode) {
        setInviteCode(storedInviteCode);
      }
    }
  }, [ref]);

  return inviteCode;
};
